export default __webpack_public_path__ + "static/media/porfiriowithsign.3f562a9e.jpeg";